import React from 'react';
import pt from 'prop-types';
import {withRouter} from 'react-router';
import getRoutes from './routes/routes';
import EpicGamesNavWrapper from './components/nav/EpicGamesNavWrapper';
import Footer from './components/footer/Footer';
import styled from 'styled-components';
import {UeThemeProvider, ueClassicDarkTheme} from 'epic-ue-theme';
import {makeFormStyleOverrides} from 'epic-ue-theme/src/ueFormStyles';
import Immutable from 'seamless-immutable';
import {StoreProvider} from './stores';
import bingSearchColors from 'epic-react-search/app/scripts/theme/colors';
import {createGlobalStyle} from 'styled-components';

const theme = {
    colors: {
        white: '#fff'
    },
    bingSearch: bingSearchColors,
    placeholder: {
        color: '#cdcdcd',
        animation: 'react-placeholder-pulse 1.5s infinite'
    },
    fonts: {
        brutal: {
            bold: 'Brutal_Bold',
            medium: 'Brutal_Medium',
            regular: 'Brutal_Regular',
            light: 'Brutal_Light'
        }
    }
};

const GlobalStyle = createGlobalStyle`
    html, body {
        background-color: ${p => p.theme.palette.background.default};
        color: ${p => p.theme.palette.text.primary};
        font-family: OpenSans,sans-serif,arial;
        -webkit-font-smoothing: antialiased;
        &.ko {
            word-wrap: break-word;
            word-break: keep-all;
        }
    }
    .ue-react {
        background-color: ${p => p.theme.palette.background.default};
        color: ${p => p.theme.palette.text.primary};
        font-family: ${p => p.theme.ue.fonts.brutal.regular};
    }
`;

const AppContainer = styled.div`
    min-height: 50vh;
    background: #1d1d1d;
`;

const AppContent = styled.div`
    min-height: 50vh;
`;

class App extends React.Component {
    static propTypes = {
        appState: pt.object
    };

    render() {
        const routes = getRoutes();
        const appState = this.props.appState || {};
        const epicGamesHeader = appState.epicGamesHeader || {};
        const headerStore = Immutable({config: epicGamesHeader});
        const epicGamesFooter = appState.epicGamesFooter || {};
        const footerStore = Immutable({config: epicGamesFooter});

        ueClassicDarkTheme.overrides = makeFormStyleOverrides(ueClassicDarkTheme);

        return (
            <UeThemeProvider theme={Object.assign({}, ueClassicDarkTheme, theme)}>
                <GlobalStyle />
                <StoreProvider initialValue={appState}>
                    <AppContainer className="ue-react">
                        <EpicGamesNavWrapper headerStore={headerStore} {...this.props} />
                        <AppContent>{routes}</AppContent>
                        <Footer footerStore={footerStore} {...this.props} />
                    </AppContainer>
                </StoreProvider>
            </UeThemeProvider>
        );
    }
}

export default withRouter(App);
